<template>
  <div id="wuPage" class="questionBank">
    <div class="table-page-search-wrapper" v-if="!taskId">
        <a-form  @keyup.enter.native="searchQuery" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" name="basic">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="题库">
                <j-dict-select-tag placeholder="请选择题库" 
                 :trigger-change="true"
                 @change="questionLibraryChange"
                 v-model="queryParam.questionLibrary"
                 :defaultShowAll="true"
                 dictCode="question_library" />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="4">
              <a-form-item label="状态">
                <j-dict-select-tag placeholder="请选择状态" v-model="queryParam.questionStatus" dictCode="question_status" />
              </a-form-item>
            </a-col> -->
            <!-- <a-col :span="4">
              <a-form-item label="题型">
                <j-dict-select-tag placeholder="请选择题型" v-model="queryParam.questionType" dictCode="question_type" />
              </a-form-item>
            </a-col> -->
            <a-col :span="5">
              <a-form-item label="难度">
                <j-dict-select-tag placeholder="请选择难度" v-model="queryParam.questionDifficulty" dictCode="question_difficulty" />
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="题目名">
                <a-input placeholder="请输入题目名" v-model="queryParam.questionName"></a-input>
              </a-form-item>
            </a-col>
            <!-- <a-col :span="4">
              <a-form-item label="题干">
                <a-input placeholder="请输入题干关键词" v-model="queryParam.questionStem"></a-input>
              </a-form-item>
            </a-col> -->
            <a-col :span="6">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px" v-if="type == 2">新增</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

    <a-table
      ref="table"
      bordered
      size="middle"
      rowKey="questionId"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="esContent" slot-scope="text">
        <j-ellipsis :value="text" :length="30" />
      </span>
      <template slot="htmlSlot" slot-scope="text">
        <a-popover title="题干预览" placement="right">
          <div slot="content" v-html="text"></div>
          <a-icon type="eye" theme="twoTone" />
        </a-popover>
      </template>

      <span slot="action" slot-scope="text, record">
        <a @click="toQuestionHistory(record)">答题记录</a>
        <a-divider type="vertical"></a-divider>
        <a @click="toQuestion(record)">去做题</a>
      </span>
    </a-table>
  </div>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
import JEllipsis from "@/components/jeecg/JEllipsis";
export default {
  name: "questionBank",
  mixins: [JeecgListMixin],
  components:{
    JEllipsis
  },
  data() {
    return {
      columns: [
        {
          title: "#",
          dataIndex: "",
          key: "rowIndex",
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          },
        },
        // {
        //   title: "题型",
        //   align: "center",
        //   dataIndex: "questionType_dictText",
        // },
        {
          title: "题库",
          align: "center",
          // width: 70,
          dataIndex: 'questionLibrary_dictText',
          customRender(v,r){
            if(v){
              return v
            }else{
              return r.questionLibrary
            }
          }
        },
        {
          title: "题目名",
          align: "center",
          dataIndex: "questionName",
          scopedSlots: { customRender: "esContent" },
        },
        {
          title: "题干",
          align: "center",
          dataIndex: "questionStem",
          width: 70,
          scopedSlots: { customRender: "htmlSlot" },
        },
        {
          title: "难度",
          align: "center",
          width: 70,
          dataIndex: 'questionDifficulty_dictText'
        },
        {
          title: "分值",
          align: "center",
          width: 80,
          dataIndex: "questionScore",
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          align: "center",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingQuestion/getMyPublicList?questionType=8",
      },
      disableMixinCreated: true, //禁用mixin的created方法
      unitInfo: {},
      queryParam: {
        questionLibrary: ''
      },
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadData(1);
    },
    toQuestion(q) {
      window.open("/onlinecode/index.html?questionId=" + q.questionId);
    },
    toQuestionHistory(q){
      let url = this.$router.resolve({
        name: 'questionHistory',
        query:{
          id: q.questionId
        }
      }).href
      window.open(url)
    },
    questionLibraryChange(v) {
        console.log(v);
        this.queryParam.questionLibrary = v
        this.searchQuery()
      },
  },
};
</script>

<style >
.questionBank{
    padding: 20px;
}
</style>